module.exports = __webpack_public_path__ + "img/blue.9988c45a.png";